import { appConfig as $config } from '../../app.config';
import { App } from '../App';
import { UI } from '../UI';
import { ExportTo } from '../ExportTo';
import { pdfcss } from './pdfcss';
import { User } from '../User';

import './scss/productapprovalfull.scss';

export const ProductApprovalFull = (function () {
  let $el = {};
  let $product;
  let $licensedProductId;

  let mapping = (product) => {
    // process dates
    product.date = moment(product.date).format($config.appFullDateFormat);

    product.mockups.forEach((mock) => {
      mock.colorHex = mock.colorHex ? mock.colorHex : mock.blankColor;
    });
    return product;
  };

  let init = (element, licensedProductId) => {
    $el = element;
    $licensedProductId = licensedProductId;
    UI.block(element);

    $.when(App.ajaxData(`LicensedProductApprove/${User.accountID()}/${$licensedProductId}/full`, {})).done((res) => {
      $product = mapping(res.data);
      pageInit($product);
    });
  };

  let pageInit = (product) => {
    let pageData = {
      ...{
        product,
        $lang: $lang
      }
    };

    let template = require('./tmpl/productapprovalfull.hbs');
    UI.page(template, pageData, false).then(() => {
      // Page Loaded INFRAME PostMessage
      onLoadMessage();

      clickHandler();
      UI.unblock($el);
    });
  };

  let clickHandler = () => {
    $('#page')
      .off()
      .on('click', '.js-product-approve', approve)
      .on('click', '.js-product-disapprove', disapprove)
      .on('click', '.js-product-export', exportToPdf);
  };

  let onLoadMessage = () => {
    if (window.self === window.top) return;
    if (window.parent) {
      window.parent.postMessage({ pageloaded: true }, '*');
    }
  };

  let approve = () => {
    var section = $product.approveItem;
    section.approved = true;
    section.comments = null;
    UI.block($el);


    $.when(App.ajaxData(`LicensedProductApprove/${User.accountID()}/${$licensedProductId}/full`, section, 'PUT')).done(
      () => {
        init($el, $licensedProductId);
      }
    );
  };

  let disapprove = () => {
    var section = $product.approveItem;

    bootbox.prompt({
      size: 'medium',
      title: $lang.productApprovalFull.comments,
      message: $lang.productApprovalFull.allWillBeDisapproved,
      value: section.comments,
      callback: function (result) {
        if (result == null) {
          return;
        }

        section.approved = false;
        section.comments = result;
        UI.block($el);

        $.when(
          App.ajaxData(`LicensedProductApprove/${User.accountID()}//${$licensedProductId}/full`, section, 'PUT')
        ).done(() => {
          init($el, $licensedProductId);
        });
      }
    });
  };

  let exportToPdf = () => {
    ExportTo.pdf({
      selector: '#productApprovalCard-full',
      css: pdfcss
    });
  };

  return {
    init,
    approve,
    disapprove
  };
})();
